import Vue from 'vue';
import Vuex from 'vuex';

import {
  USER_URL,
} from '../../vars';

Vue.use(Vuex);

/**
 * @namespace Main
 */
export default new Vuex.Store({
  state: {
    current_news: {},
    show_news: false,

    appLanguage: localStorage.getItem("language") || process.env.VUE_APP_I18N_LOCALE || 'ru',
  },

  mutations: {
    SET_CURRENT_NEWS(state, payload) {
      // console.log('SET_CURRENT_NEWS', payload)
      state.current_news = payload;
    },

    SET_SHOW_NEWS(state, payload) {
      // console.log('SET_SHOW_NEWS', payload)
      state.show_news = payload;
    },
  
    SET_APP_LANGUAGE(state, language) {
  
      state.appLanguage = language;
      localStorage.setItem("language", language); // Whenever we change the appLanguage we save it to the localStorage
    },
  },

  actions: {
    async LANGUAGE_SWITCH(ctx, data) {
      try {
          const res = await axios.patch(LANGUAGE_URL, data, {headers: {
              Authorization: `Token ${localStorage.token}`,
          }});

          await ctx.commit('SET_APP_LANGUAGE', res.data.language)
      } catch(e) {
          errorHelper(e)
          messageHelper('', 'error', 6000, e)
          throw e
      }
    }
  },

  getters: {
    GETTERS_CURRENT_NEWS(state) {
      return state.current_news;
    },

    GETTERS_SHOW_NEWS(state) {
      return state.show_news;
    },

    GETTERS_APP_LANGUAGE(state) {
      return state.appLanguage
    },
  },
  modules: {

  },
});
